var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8312 0.168786C12.0563 0.393834 12.0563 0.758709 11.8312 0.983757L0.983757 11.8312C0.758709 12.0563 0.393834 12.0563 0.168786 11.8312C-0.056262 11.6062 -0.056262 11.2413 0.168786 11.0162L11.0162 0.168786C11.2413 -0.056262 11.6062 -0.056262 11.8312 0.168786Z",
    fill: "#0F2342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.168785 0.168786C-0.056263 0.393834 -0.056263 0.758709 0.168785 0.983757L11.0162 11.8312C11.2413 12.0563 11.6062 12.0563 11.8312 11.8312C12.0563 11.6062 12.0563 11.2413 11.8312 11.0162L0.983757 0.168786C0.758708 -0.056262 0.393834 -0.056262 0.168785 0.168786Z",
    fill: "#0F2342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.5d68a5800c665e2031f081f8b6bf98d7.svg";
export { ForwardRef as ReactComponent };